(() => {
  const SELECTORS = [
    '.felicitas-stats__item',
    '.felicitas-jonas__content',
    '.felicitas-jonas__media',
    '.felicitas-competencies__header',
    '.felicitas-competencies__card',
    '.felicitas-timeline__header',
    '.felicitas-timeline__item',
    '.felicitas-philosophy__content',
    '.felicitas-philosophy__quote-wrap',
    '.felicitas-expertise-cta__references > *',
    '.felicitas-expertise-cta__card',
    '.felicitas-expertise-cta__panel'
  ];

  const addRevealClasses = () => {
    const elements = document.querySelectorAll(SELECTORS.join(','));

    elements.forEach((element, index) => {
      if (element.classList.contains('felicitas-reveal')) return;

      element.classList.add('felicitas-reveal');

      const delay = (index % 4) + 1;
      element.classList.add(`felicitas-reveal-delay-${delay}`);
    });

    return elements;
  };

  const initializeReveals = () => {
    const elements = addRevealClasses();

    if (!elements || elements.length === 0) return;

    if (
      window.matchMedia('(prefers-reduced-motion: reduce)').matches ||
      !('IntersectionObserver' in window)
    ) {
      elements.forEach((element) => {
        element.classList.add('is-visible');
      });

      return;
    }

    const observer = new IntersectionObserver(
      (entries, currentObserver) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;

          entry.target.classList.add('is-visible');
          currentObserver.unobserve(entry.target);
        });
      },
      {
        root: null,
        threshold: 0.12,
        rootMargin: '0px 0px -40px 0px'
      }
    );

    elements.forEach((element) => {
      observer.observe(element);
    });
  };

  const start = () => {
    window.requestAnimationFrame(initializeReveals);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }

  document.addEventListener('shopify:section:load', start);
})();